<template>
  <div v-if="detailsData">
    <div class="Publisher">
      <div class="title">期刊</div>
      <div @click="goBk" class="logo">
        <img
          v-if="periodicalInfo.headImg"
          v-lazy="`${$global.imgUrl}${periodicalInfo.headImg}`"
          alt
        />
        <img v-else src="@/assets/img/details/qikan.png" alt />

        <span>{{ periodicalInfo.name }}</span>
      </div>
      <div class="list">
        <!-- <div class="listItem">
          <div v-if="periodicalInfo.foundedDate" class="time">
            {{ periodicalInfo.foundedDate }}
          </div>
          <div class="time" v-else>--</div>
          <div class="text">创刊时间</div>
        </div> -->
        <div class="listItem">
          <div class="time">{{ periodiID.thesisCount }}</div>
          <div class="text">文献数</div>
        </div>
        <div class="listItem">
          <div class="time">{{ periodiID.informationCount }}</div>
          <div class="text">资讯数</div>
        </div>
        <!-- <div class="listItem">
          <div class="time">{{ periodiID.letterCount }}</div>
          <div class="text">征稿函</div>
        </div> -->
      </div>
    </div>
    <div class="wenxian">
      <div class="title">最新资讯</div>
      <ul class="ulList" v-if="wenxian.length > 0">
        <li
          :class="i + 1 === wenxian.length ? '' : 'msg'"
          v-for="(item, i) in wenxian"
          :key="item.articleId"
          style="cursor: pointer"
          @click="goDetail(item)"
        >
          {{ item.title }}
        </li>
      </ul>
      <div v-else style="padding: 30px">暂无数据</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "right",
  props: [
    "detailsData",
    "periodicalInfo",
    "periodicalId",
    "wenxian",
    "periodiID",
  ],
  data() {
    return {};
  },
  methods: {
    goDetail(e) {
      console.log(e);
      let routeUrl;
      if (e.articleType === 0 && e.type === 0) {
        routeUrl = this.$router.resolve({
          path: "/thesisDetail",
          query: {
            type: e.articleType,
            id: e.articleId,
          },
        });
      } else if (e.articleType === 0 && e.type === 3) {
        routeUrl = this.$router.resolve({
          path: "/thesisDetail",
          query: {
            type: e.articleType,
            id: e.articleId,
          },
        });
      } else if (e.articleType === 6) {
        routeUrl = this.$router.resolve({
          path: "/dataDetails",
          query: {
            type: e.articleType,
            id: e.articleId,
          },
        });
      } else if (e.articleType === 5) {
        routeUrl = this.$router.resolve({
          path: "/msgDetails",
          query: {
            type: e.articleType,
            id: e.articleId,
          },
        });
      }
      window.open(routeUrl.href, "_blank");
    },
    goBk() {
      // console.log(this.periodicalInfo.id);
      // this.$router.push(`/bkzxdetail?title=百科在线&id=${this.periodicalInfo.id}`)
      let routeUrl = this.$router.resolve(
        {
          path: "/bkzxdetail",
          query: {
            title: "百科在线",
            id: this.detailsData.perId,
          },
        }
        //
      );
      window.open(routeUrl.href, "_blank");
    },
  },
  // created() {
  //   console.log(this.detailsData)
  // }
};
</script>

<style lang="scss" scoped>
.wenxian {
  width: 270px;
  //height: 250px;
  //padding-left: 25px;
  padding-top: 20px;
  padding-bottom: 40px;
  background: #ffffff;
  margin-left: 10px;
  // box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.1);
    border: 1px solid #A3CBE7;
  border-radius: 10px;
  //.xian{
  //  width: 270px;
  //  height: 1px;
  //  top: 60px;
  //  border: 1px solid #E5E5E5;
  //  background: pink;
  //  right: 0px;
  //}
  a {
    color: #666666;
  }
  .ulList {
    padding-left: 25px;
    padding-right: 25px;

    li {
      //width: 240px;
      //height: 37px;
      margin-top: 15px;
      padding-bottom: 15px;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
    }

    .msg {
      //width: 240px;
      //height: 37px;
      margin-top: 15px;
      padding-bottom: 15px;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      //line-height: 24px;
      border-bottom: 1px dashed #e8e8e8;
      //border-style: dashed;
    }
  }

  .title {
    font-size: 18px;

    font-weight: bold;
    height: 20px;
    line-height: 20px;
    color: #333333;
    width: 270px;
    padding-left: 25px;
    padding-bottom: 40px;
    border-bottom: 1px solid #e5e5e5;
    //border-bottom: 1px solid #000;
  }
}

.Publisher {
  width: 270px;
  height: 250px;
  padding-left: 25px;
  padding-top: 20px;
  background: #ffffff;
  // box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.07);
    border: 1px solid #A3CBE7;
  border-radius: 10px;
  margin-left: 10px;
  margin-bottom: 10px;

  .title {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    //line-height: 24px;
  }

  .logo {
    display: flex;
    width: 220px;
    flex-wrap: wrap;
    //background: pink;
    justify-content: center;
    margin-top: 10px;

    img {
      width: 84px;
      height: 84px;
      border-radius: 50%;
      cursor: pointer;
    }

    span {
      cursor: pointer;
      margin-top: 15px;
      text-align: center;
      width: 245px;
      // height: 18px;
      font-size: 18px;
      //font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;
      line-height: 24px;
      white-space: nowrap; //不换行
      overflow: hidden; //超出隐藏
      text-overflow: ellipsis; //变成...
    }
  }

  .list {
    width: 220px;
    display: flex;
    margin-top: 24px;
    justify-content: space-around;

    .listItem {
      width: 50px;
      height: 50px;
      text-align: center;
      align-items: center;

      .text {
        text-align: center;
        //width: 48px;
        //height: 11px;
        font-size: 12px;
        font-weight: 400;
        color: #666666;
        line-height: 24px;
      }

      .time {
        //background: pink;
        //width: 44px;
        //height: 17px;
        font-size: 20px;
        font-family: Dancing Script;
        font-weight: bold;
        color: #ff7d14;
        line-height: 24px;
        text-align: center;
      }
    }
  }
}
</style>
